import {useRef, useState} from 'react'
import {Link, NavLink} from 'react-router-dom'

import {CreditstarLogo, MobileMenuOpen} from '../../assets/icons'
import useWindowSize from '../../hooks/useWindowSize'
import {APP_ROUTES} from '../../routes/routes'
import HeaderMobileMenu from './HeaderMobileMenu'
import HeaderSubMenu from './HeaderSubMenu'

const HeaderNew = () => {
  const ref = useRef()
  const {isTabletDevice} = useWindowSize()
  const [isMobileMenuOpen, setMobileMenuState] = useState(false)

  const openMobileMenu = () => {
    setMobileMenuState(!isMobileMenuOpen)
    document.body.style.overflow = 'hidden'
  }

  const closeMobileMenu = () => {
    setMobileMenuState(!isMobileMenuOpen)
    document.body.style.overflow = 'auto'
  }

  return (
    <header id="header" ref={ref}>
      <div className="header-wrapper">
        <div className="header-logo">
          <Link
            to={APP_ROUTES.ROOT}
            onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}
          >
            <CreditstarLogo />
          </Link>
        </div>
        {!isTabletDevice && 
          <div className="header-links">
            <div className="header-link">
              <NavLink to={APP_ROUTES.ABOUT}>About Us</NavLink>
            </div>
            <div className="header-link">
              <NavLink to={APP_ROUTES.PRODUCTS}>Products</NavLink>
            </div>
            <div className="header-link">
              <NavLink to={APP_ROUTES.CAREERS}>Careers</NavLink>
            </div>
            <div className="header-link">
              <NavLink to={APP_ROUTES.BONDS}>Investors</NavLink>
            </div>
            <div className="header-link">
              <NavLink to={APP_ROUTES.NEWS}>News</NavLink>
            </div>
            <div className="header-link">
              <NavLink to={APP_ROUTES.CONTACTS}>Contacts</NavLink>
            </div>
          </div>
        }
        {isTabletDevice && 
          <div onClick={openMobileMenu}>
            <MobileMenuOpen />
          </div>
        }
      </div>
      {isMobileMenuOpen && <HeaderMobileMenu close={closeMobileMenu} />}
      <HeaderSubMenu />
    </header>
  )
}

export default HeaderNew
